<template>
  <div>
    <b-card v-if="$route.params.id">
      <b-row>
        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">№</b>
            <b>#{{ GET_APPLICATIONS_TRANSPORT_ID.id }}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">{{$t('date')}}</b>
            <b>{{ $dayjs(GET_APPLICATIONS_TRANSPORT_ID.created_at).format("DD.MM.YYYY") }}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column align-items-center">
            <b class="mb-25">{{$t('status')}}</b>
            <b-badge
              v-if="GET_APPLICATIONS_TRANSPORT_ID.status"
              :variant="GET_APPLICATIONS_TRANSPORT_ID.status.color"
            >
              {{ GET_APPLICATIONS_TRANSPORT_ID.status.name }}
            </b-badge>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <validation-observer ref="materialValidate">
      <b-card>
        <div class="material">
          <div class="d-flex align-items-center justify-content-between">
            <h4>{{$t('transports')}}</h4>

            <b-button variant="primary" @click="onSubmitTransport">
              <feather-icon icon="PlusIcon" size="16" />
              {{$t('add')}}
            </b-button>
          </div>
          <hr />
        </div>
        
        <b-table
          :fields="fieldsTable"
          :items="allData.transports"
          responsive
          hover
          :empty-text="$t('empty_text')"
          show-empty
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(numeration)="props">
            <span>{{ props.index + 1 }}</span>
          </template>
        
          <template #cell(start_date)="props">
            <div>
              {{ props.item && props.item.start_date ? $dayjs(props.item.start_date).format('DD.MM.YYYY, HH:mm') : '-' }}
            </div>
          </template>

          <template #cell(working_hours)="props">
            <span v-if="props && props.item && props.item.working_hours && props.item.working_hours">
              {{ props.item.working_hours }}
            </span>
          </template>
          
          <template #cell(price_per_hour)="props">
            <span v-if="props && props.item && props.item.price_per_hour && props.item.price_per_hour">
              {{ props.item.price_per_hour }}
            </span>
          </template>

          <template #cell(transport)="props">
            <span v-if="props && props.item && props.item.transport_id && props.item.transport_id.title">
              {{ props.item.transport_id.title }}
            </span>
          </template>

          <template #cell(actions)="props">
            <b-button size="sm" variant="warning" @click="transportEdit(props)" class="mt-50 mb-50">
              <feather-icon icon="EditIcon" size="15" />
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              class="ml-50 mt-50 mb-50"
              @click="removeItem(props)"
            >
              <feather-icon icon="TrashIcon" size="15" />
            </b-button>
          </template>
        </b-table>

        <div class="warehouse mt-2">
          <h4>{{$t('sidebar.warehouse')}}</h4>
          <hr />

          <b-row>
            <b-col md="3">
              <b-form-group :label="$t('destination_warehouse')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('destination_warehouse')"
                  rules="required"
                >
                  <v-select
                    v-model="allData.storage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="GET_WAREHOUSE"
                    :reduce="(p) => p.id"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <div class="d-flex align-items-center justify-content-end mt-3">
        <b-button class="mr-1" variant="outline-secondary" @click="cancel">
          {{ $t("cancel") }}
        </b-button>

        <b-button
          :variant="$route.params.id ? 'warning' : 'success'"
          :disabled="buttonPressed"
          @click="saveAllActions"
        >
          {{ $t("save") }}
        </b-button>
      </div>
    </validation-observer>

    <fields :transportss="transportss" @onSave="onSave" />
  </div>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BCard,
  BTable,
  BBadge
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required } from "@core/utils/validations/validations";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import areYouSure from "@/mixins/areYouSure";
import objective from "@/mixins/objective";
import fields from "./fields.vue";
import useJwt from "@/auth/jwt/useJwt";
import loader from "@/mixins/loader";

export default {
  name: "add-transport",
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    vSelect,
    BCard,
    BTable,
    fields,
    ValidationObserver,
    ValidationProvider,
    BBadge
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure, objective, loader],
  data() {
    return {
      required,





      // ===============  PRIMARY_DATA_SECTION START ===============
      fieldsTable: [
        {
          label: "№",
          key: "numeration",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "date",
          key: "start_date",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "transport",
          key: "transport",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "amount",
          key: "count",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "price_per_hour",
          key: "price_per_hour",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "hours_used",
          key: "working_hours",
          thClass: "text-center",
          tdClass: "text-center",
        },
         {
          label: "contact.comment",
          key: "comment",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],

      allData: {
        transports: [],
        storage: null,
        device: {type: "desktop"}
      },

      transportss: {},
      index: null,
      buttonPressed: false
      // ===============  PRIMARY_DATA_SECTION END ===============





    };
  },
  computed: {
    ...mapGetters("obectsWarehouse", ["GET_WAREHOUSE"]),
    ...mapGetters("application", ["GET_APPLICATIONS_TRANSPORT_ID"])
  },
  watch: {
    'allData.transports': {
      deep: true,
      handler(newValue){
        
      }
    }
  },

  async mounted() {



    // await this.$_loaderStart();

    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    const { storage_object } = useJwt.getUserData();
    await this.FETCH_WAREHOUSE({ mini: true, is_object: true });
    this.allData.storage = storage_object ?? null;
    if (this.$route.params.id) {
      await this.FETCH_APPLICATIONS_TRANSPORT_ID(this.$route.params.id).then(() => {
          const { transports, storage } = this.GET_APPLICATIONS_TRANSPORT_ID;

          this.allData.transports = transports.map(el => ({
            id: el.id,
            start_date: el.start_date,
            transport_id: el.transport,
            count: el.count,
            comment: el.comment,
            price_per_hour: el.price_per_hour,
            working_hours: el.working_hours,
          }));
          this.allData.storage = storage.id;
        });
    }
    // ===============  PRIMARY_REQUESTS_SECTION START ===============




  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "CREATE_APPLICATION_TRANSPORT",
      "FETCH_APPLICATION_TRANSPORT",
      "FETCH_APPLICATIONS_TRANSPORT_ID",
      "UPDATE_APPLICATION_TRANSPORT",
      "DELETE_TRANSPORT_INSIDE"
    ]),
    ...mapActions("obectsWarehouse", ["FETCH_WAREHOUSE"]),









    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitTransport() {
      this.transportss = {};
      this.index = null;
      this.$nextTick(() => {
        this.$bvModal.show("modal-field");
      });
    },
    findFirstIndex(){
      let a = ''
      this.allData.transports.forEach((elem2, index2) => {
        a = this.allData.transports.findIndex((elem, index) => {
            if(elem.transport_id.id == elem2.transport_id.id){
              return elem
            }
        })
      })
      return a
    },
    findSecondIndex(){
      let a = ''
      this.allData.transports.forEach((elem2, index2) => {
        a = this.allData.transports.findLastIndex((elem, index) => {
            if(elem.transport_id.id == elem2.transport_id.id){
              return elem
            }
        })
      })
      return a
    },
    onSave(el) {
      if (typeof this.index === "number") {
        this.allData.transports.splice(this.index, 1, el);
      } else {
        this.allData.transports.push(el);
      }


      this.allData.transports.forEach((elem, index) => {

        let count = 0;
        let firstIndex = '';
        let secondIndex = '';

        this.allData.transports.forEach((elem2, index2) => {
          if(elem2.transport_id.id == elem.transport_id.id){
            count++;
          }
        })


        if(count == 2){
          firstIndex = this.findFirstIndex()
          secondIndex = this.findSecondIndex()

          this.allData.transports[firstIndex].count = parseFloat((this.allData.transports[firstIndex].count).toString().replace(/,/g, ''))
           + parseFloat((this.allData.transports[secondIndex].count).toString().replace(/,/g, ''))


          this.allData.transports[firstIndex].count = parseFloat(this.allData.transports[firstIndex].count);
          this.allData.transports[firstIndex].count = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(this.allData.transports[firstIndex].count);
          this.allData.transports.splice(secondIndex, 1)
        }
      })
    },









    async saveAllActions() {
      this.$refs.materialValidate.validate().then(async success => {
        this.buttonPressed = true
        setTimeout(() => {
          this.buttonPressed = false
        }, 2000)
        if (!success) return;

        // eslint-disable-next-line prefer-const
        let { transports, ...rest } = this.allData;

        transports = transports.map(e => {

          let a = {
            id: e.id ? e.id : null,
            start_date: e.start_date,
            transport_id: e.transport_id.id ? e.transport_id.id : e.transport_id,
            count: parseFloat(e.count.toString().replace(/,/g, '')),
            working_hours: e.working_hours,
            price_per_hour: e.price_per_hour,
            comment: e.comment,
          }

          return a
        })
        
        

        const data = {transports, ...rest};
        if (this.$route.params.id) {
          await this.UPDATE_APPLICATION_TRANSPORT({
            id: this.$route.params.id,
            transports,
            ...rest
          }).then(async () => {
            await this.FETCH_APPLICATION_TRANSPORT();
            this.$router.push({ name: "applications-transport" });
          });
        } else {
          await this.CREATE_APPLICATION_TRANSPORT(data).then(async () => {
            await this.FETCH_APPLICATION_TRANSPORT();
            this.$router.push({ name: "applications-transport" });
          });
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============









    // ===============  EDIT_SECTION START ===============
    transportEdit(props) {
      this.transportss = props.item;
      this.index = props.index;
      this.$route.params.editMode = true
      this.$nextTick(() => {
        this.$bvModal.show("modal-field");
      });
    },
    // ===============  EDIT_SECTION START ===============








    // ===============  CANCEL_SECTION START ===============
    cancel() {
      this.allData.transports = [
        {
          category: "",
          transport_id: "",
          count: null,
          status: false
        }
      ];
      this.$router.push({ name: "applications-transport" });
    },
    // ===============  CANCEL_SECTION END ===============









    // ===============  REMOVE_SECTION START ===============
    async removeItem(props) {
      if (props.item.id) {
        this.$_showAreYouSureModal().then(async (val) => {
          if (val) {
            await this.DELETE_TRANSPORT_INSIDE(props.item.id)
              .then(() => {
                this.allData.transports.splice(props.index, 1);
                this.$_okToast();
              })
              .catch(err => {
                this.$_errToast(err);
              });
          }
        });
      } else {
        this.allData.transports.splice(props.index, 1);
      }
    }
    // ===============  REMOVE_SECTION END ===============








  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
